import React from 'react';
import CommonChart from '../CommonChart';
import { getCompetitorBatchChannel } from '@/pages/opinion/services';

export default function ChannelChart({
  xAxisList,
  dau,
  commonParams,
  isNoMobile,
}: any) {
  return (
    <CommonChart
      xAxisList={xAxisList}
      dau={dau}
      commonParams={commonParams}
      isNoMobile={isNoMobile}
      requestFunc={getCompetitorBatchChannel}
      selectTitle="Channel"
      title="Channel"
    ></CommonChart>
  );
}
